// Section 5 and 13: Volatile. Crime propensity 2x when trust is low; output 1.1x.
// Constants: config.traits.volatile, config.crime.lowTrustBelow.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function volatile(config: Config) {
  const c = config.traits.volatile;

  return defineTrait({
    id: 'volatile',
    label: 'Volatile',
    section: 'S5',
    modifierTargets: ['output', 'crimeRisk'],
    modifiers(ctx, target) {
      const p = targetPerson(ctx, target);
      if (p?.traits.includes('volatile') !== true) return [];
      if (target.kind === 'output') return [mod.mul('trait:volatile', c.outputMul, 'volatile')];
      if (target.kind === 'crimeRisk' && p.trust < config.crime.lowTrustBelow) {
        return [mod.mul('trait:volatile', c.lowTrustCrimeMul, 'volatile, low trust')];
      }
      return [];
    },
    restricts: neverRestricts,
  });
}
